import { createFileRoute, useNavigate, useParams, redirect } from '@tanstack/react-router';
import { TradingViewPro } from '../../features/terminal';
import { useEffect, useCallback } from 'react';
import useAppStore, { RootState } from '../../store/rootStore';
import { findMarketIdBySymbol } from '../../store/slices/marketSlice';

export const Route = createFileRoute('/trade/$marketSymbol')({
  component: TradeWithSymbol,
});

function TradeWithSymbol() {
  const { marketSymbol } = Route.useParams();
  const navigate = useNavigate();

  const selectMarket = useAppStore((state) => state.selectMarket);
  const selectedMarketId = useAppStore((state) => state.selectedMarketId);

  const resolvedMarketId = useAppStore(
    useCallback((state: RootState) => findMarketIdBySymbol(state.markets, marketSymbol), [marketSymbol])
  );

  const defaultMarketSymbol = useAppStore(selectDefaultMarketSymbol);

  useEffect(() => {
    if (!marketSymbol) return;

    if (resolvedMarketId != null) {
      if (selectedMarketId !== resolvedMarketId) {
        selectMarket(resolvedMarketId);
      }
    } else if (defaultMarketSymbol) {
      if (defaultMarketSymbol.toUpperCase() !== marketSymbol.toUpperCase()) {
        navigate({ to: '/trade/$marketSymbol', params: { marketSymbol: defaultMarketSymbol || 'BTC' }, replace: true });
      }
    }
  }, [marketSymbol, resolvedMarketId, defaultMarketSymbol, selectedMarketId, selectMarket, navigate]);

  return <TradingViewPro />;
}

const selectDefaultMarketSymbol = (state: RootState) => {
  if (state.markets.size === 0) return undefined;
  return state.markets.values().next().value?.symbol;
};
